// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bookUser_input[data-v-41b3229c] .el-input__inner {\n  cursor: pointer;\n}\n.createForm-box[data-v-41b3229c] .el-form {\n  padding-right: 0px;\n}\n.htmlContent[data-v-41b3229c] {\n  max-height: 400px;\n  overflow: auto;\n  display: flex;\n  justify-content: center;\n}\n.htmlContent[data-v-41b3229c] img {\n  display: block;\n  max-width: 100%;\n  max-height: 300px;\n}\n", ""]);
// Exports
module.exports = exports;
